var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"reportPage webReport"},[_c('initialValuationReport',{attrs:{"stage":_vm.stage,"type":_vm.type,"url":_vm.url,"typeName":_vm.typeName}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }